var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    y: 0.25,
    width: 9.5,
    height: 9.5,
    rx: 4.75,
    transform: "matrix(1 0 0 -1 0.5 10)",
    stroke: "#E05757",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.45919C5.49706 7.31353 5.44117 7.175 5.34445 7.07369C5.24767 6.97237 5.1179 6.91648 4.98329 6.91809C4.88518 6.92164 4.79024 6.95634 4.71024 7.01791C4.63019 7.07948 4.56874 7.1652 4.53347 7.26433C4.49814 7.36346 4.49058 7.47165 4.51175 7.57541C4.53286 7.67916 4.58174 7.77384 4.6523 7.84773C4.72285 7.92161 4.81191 7.97139 4.9084 7.99084C5.0049 8.0103 5.10462 7.99859 5.19501 7.95716C5.28539 7.91572 5.3625 7.84641 5.41672 7.75786C5.471 7.66931 5.49994 7.56543 5.5 7.45919ZM4.58891 2.4208V5.65545C4.58741 5.71227 4.59652 5.76884 4.61574 5.82169C4.63497 5.87454 4.66385 5.92264 4.70074 5.96304C4.73757 6.00351 4.78163 6.03549 4.83018 6.05702C4.87874 6.07854 4.93085 6.08924 4.98329 6.0884C5.03507 6.08846 5.08634 6.07716 5.13395 6.05515C5.18156 6.03321 5.22462 6.00104 5.26045 5.96058C5.29628 5.92012 5.32412 5.87226 5.34239 5.81983C5.36067 5.7674 5.36889 5.71149 5.36661 5.65545V2.4208C5.36661 2.36555 5.35656 2.31084 5.33706 2.25979C5.3175 2.20875 5.28884 2.16233 5.25273 2.12325C5.21662 2.08417 5.17379 2.05321 5.12662 2.03205C5.0794 2.01088 5.02884 2 4.97779 2C4.92674 2 4.87613 2.01088 4.82896 2.03205C4.78179 2.05321 4.73891 2.08417 4.7028 2.12325C4.66669 2.16233 4.63802 2.20875 4.61852 2.25979C4.59897 2.31084 4.58891 2.36555 4.58891 2.4208Z",
    fill: "#E05757",
    stroke: "#E05757",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipAlert);
export default __webpack_public_path__ + "static/media/tooltip-alert.53c4049e0650f3d0fc77c4c07207d84a.svg";
export { ForwardRef as ReactComponent };